export default function useOtp({
  enableAfterInSeconds = 120,
  isSendOTPBtnDisabled,
  isLoading,
  phone,
  payload,
}) {
  const { clearTimer, getDeadTime, timer } = useTimer();

  const { sendOTPForPRsProcessing } = usePaymentRequestStore();

  const handleIsSendOTPBtnClicked = inject("handleIsSendOtpBtnClicked");

  const sendOTP = async () => {
    try {
      handleIsSendOTPBtnClicked(true);

      isSendOTPBtnDisabled.value = true;

      phone.value = null;

      isLoading.value = true;

      const response = await sendOTPForPRsProcessing(payload);

      if (response?.data?.data?.phone) {
        phone.value = response?.data?.data?.phone;
      }

      await clearTimer(getDeadTime());

      setTimeout(() => {
        isSendOTPBtnDisabled.value = false;
      }, 1000 * enableAfterInSeconds); // enable after 10 seconds for testing purpose
    } catch (error) {
      console.error(error);

      isSendOTPBtnDisabled.value = false;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    sendOTP,
    timer,
  };
}
